import {Group, Stack, Text, Tooltip} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface RoutineFieldHeaderProps {
  title: string;
  description?: string;
  titleTooltip?: string;
}

/**
 * Shared section header for the Agent (Routine) form. Matches the
 * built-in Mantine input label/description styling (`md`/bold title, `md`/dimmed
 * description) so every custom section header lines up with the Name/Description/
 * Instructions inputs.
 */
export default function RoutineFieldHeader({
  title,
  description,
  titleTooltip,
}: RoutineFieldHeaderProps): JSX.Element {
  return (
    <Stack spacing={4}>
      <Group spacing={4} align="center" noWrap={true}>
        <Text size="md" fw="bold">
          {title}
        </Text>
        {titleTooltip != null && (
          <Tooltip label={titleTooltip} withArrow={true} multiline={true} maw={260} position="top">
            <Text span={true} c="dimmed" display="inline-flex" role="img" aria-label={titleTooltip}>
              <BenchlingIcon icon="info-circle" />
            </Text>
          </Tooltip>
        )}
      </Group>
      {description != null && (
        <Text size="md" c="dimmed">
          {description}
        </Text>
      )}
    </Stack>
  );
}
